<app-modal-basic #modalRelatorio (closed)="destroyComponent()">
    <div class="app-modal-header">
        <h4 class="modal-title">Relatório de entradas e saídas de Itens</h4>
    </div>
    <div class="app-modal-body">
        <form [formGroup]="impressaoForm" (ngSubmit)="submitForm()">
          <div class="row">
            <div class="form-group col-sm-12">
              <label>Emissão</label>
              <div class="input-group">
                <app-data [calendarPosition]="'left'" formControlName="periodo1"></app-data>
                <span class="input-group-addon">até</span>
                <app-data formControlName="periodo2"></app-data>
              </div>
            </div>
          </div>

              
          <div class="row form-group col-sm-12">
            <div>
              <span>Formato</span>
            </div>

            <div class="form-radio form-control" style="border: unset; padding-left: 0px;">
              <div class="radio radio-inline">
                <label style="margin-bottom: 0px;">
                  <input type="radio" formControlName="pdf" [value]='true'
                    [disableControl]="loading['disable'] || loading['request']">
                  <i class="helper"></i><span> PDF</span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label style="margin-bottom: 0px;">
                  <input type="radio" formControlName="pdf" [value]='false'
                    [disableControl]="loading['disable'] || loading['request']">
                  <i class="helper"></i><span> XLSX</span>
                </label>
              </div>
            </div>
          </div>

                <div class="row form-group col-sm-12">
            <div>
              <span>Agrupamento</span>
            </div>

            <div class="form-radio form-control" style="border: unset; padding-left: 0px;">
              <div class="radio radio-inline">
                <label style="margin-bottom: 0px;">
                  <input type="radio" formControlName="normal" [value]='true'
                    [disableControl]="loading['disable'] || loading['request']">
                  <i class="helper"></i><span> Normal</span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label style="margin-bottom: 0px;">
                  <input type="radio" formControlName="normal" [value]='false'
                    [disableControl]="loading['disable'] || loading['request']">
                  <i class="helper"></i><span> Por NF-E</span>
                </label>
              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary ripple light" [disabled]="loading">
            <app-loading [loading]="loading" [icone]="'icofont icofont-print'" [texto]="'Imprimir'" [textoLoading]="'Imprimindo'"></app-loading>
          </button>
          <button type="button" class="btn btn-danger ripple" (click)="modalRelatorio.hide()"><i class="ti ti-exit"></i>
            Fechar
          </button>
        </form>
      </div>
      <div class="app-modal-footer">
      </div>
</app-modal-basic>
